import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { getMeetingsApi } from "./meetingApi";

export const getMeetings = createAsyncThunk(
  "meeting/getMeetings",
  async ({ page, limit, locationId }, thunkAPI) => {
    try {
      const res = await getMeetingsApi({ page, limit, locationId });

      return res.data.data;
    } catch (err) {
      return thunkAPI.rejectWithValue(
        err.response?.data?.message || "Failed to fetch meetings"
      );
    }
  }
);

const meetingSlice = createSlice({
  name: "meeting",
  initialState: {
    meetings: [],
    total: 0,
    loading: false,
  },
  extraReducers: (builder) => {
    builder
      .addCase(getMeetings.pending, (state) => {
        state.loading = true;
      })
      .addCase(getMeetings.fulfilled, (state, action) => {
        state.loading = false;
        state.meetings = action.payload?.items || [];
        state.total = action.payload?.total || 0;
      })
      .addCase(getMeetings.rejected, (state) => {
        state.loading = false;
      });
  },
});

export default meetingSlice.reducer;